export default __webpack_public_path__ + "static/media/tokenine_logo_white.99715359.svg";